export enum ExpenseItemEnum {
  /** 全部 */
  All = 0,
  /** 掛號費 */
  RegisterFee = 1,
  /** 自費金額 */
  SelfPay = 2,
  /** 部分負擔 */
  OwnFee = 3,
  /** 押金 */
  Deposit = 4,
  /** 診察費 */
  ConsultFee = 5,
  /** 藥自付 */
  DrugOwnFee = 6,
  /** 檢自付 */
  ExamOwnFee = 7
}
